export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync.worker.09e1b0c0.worker.js");
}
